import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withLocalize, Translate } from 'react-localize-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { searchActions } from '../../../store/searchStore';
import { isEmpty, isNullOrUndefined } from '../../../store/storeFunctions';
import ResponsiveTable from "../../layoutItems/responsiveTable";

import './propertySk.scss';

class PropertySkCadastreUnitParcelList extends React.Component {
    state = {
        expanded: false
    };

    static propTypes = {
        data: PropTypes.object.isRequired,
        landTypes: PropTypes.object.isRequired,
        locations: PropTypes.object.isRequired,
        entityId: PropTypes.number,
        hash: PropTypes.object
    };

    componentDidMount() {
        if (this.props.expanded) {
            this.expandClicked()
        }
    }

    render() {
        const data = this.props.data;

        return (
            <>
                <tr className="detail-row" onClick={() => this.expandClicked()}>
                    <td>{data.unit.region}</td>
                    <td>{data.unit.district}</td>
                    <td>{data.unit.municipality}</td>
                    <td>{data.unit.name}</td>
                    <td />
                    <td />
                </tr>
                <tr className="without-hover" style={{ display: this.state.expanded ? "" : "none", backgroundColor: "inherit" }}>
                    <td style={{ display: "none" }}></td>
                    <td colSpan={6} style={{ padding: "0 0 0 2em" }}>
                        <ResponsiveTable>
                            <table className="table table-report-section table-stretched">
                                <tbody>
                                    <tr className="hide-on-mobile" style={{ borderTopWidth: 0 }}>
                                        <td className="bold"><Translate id="PropertySk.CadastreUnit.OwnershipDeedNo" /></td>
                                        <td className="bold"><Translate id="PropertySk.CadastreUnit.RecordType" /></td>
                                        <td className="bold"><Translate id="PropertySk.CadastreUnit.Area" /></td>
                                        <td className="bold"><Translate id="PropertySk.CadastreUnit.ItemType" /></td>
                                        <td className="bold"><Translate id="PropertySk.CadastreUnit.Location" /></td>
                                        <td className="bold"><Translate id="PropertySk.CadastreUnit.LandId" /></td>
                                        <td className="bold"><Translate id="PropertySk.CadastreUnit.OwnershipShare" /></td>
                                        <td className="bold"><Translate id="PropertySk.CadastreUnit.Burden" /></td>
                                    </tr>
                                    {this.renderContent(data.parcels, data.unit.unitId)}
                                </tbody>
                            </table>
                        </ResponsiveTable>
                    </td>
                </tr>
            </>
        );
    }

    renderContent = (parcels, cuId) => {
        return (
            <>
                {parcels.map((p, index) =>
                    <tr key={index} style={{ display: this.state.expanded ? "" : "none", borderBottomWidth: index === parcels.length - 1 ? 0 : "1px" }}>
                        <td data-label={this.props.translate("PropertySk.CadastreUnit.OwnershipDeedNo")}>
                            <Link className="link-internal" to={this.createOdLink(cuId, p.docNo)} target="_blank">
                                {p.docNo}
                            </Link>
                        </td>
                        <td data-label={this.props.translate("PropertySk.CadastreUnit.RecordType")}>{p.register === "C" ? this.props.translate("PropertySk.RecordType.1") : p.register === "E" ? this.props.translate("PropertySk.RecordType.0") : ""}</td>
                        <td data-label={this.props.translate("PropertySk.CadastreUnit.Area")}>{p.area}</td>
                        <td data-label={this.props.translate("PropertySk.CadastreUnit.ItemType")}>{!isEmpty(p.landTypeId) && this.props.landTypes[p.landTypeId.toString()]}</td>
                        <td data-label={this.props.translate("PropertySk.CadastreUnit.Location")}>{!isEmpty(p.locationId) && this.props.locations[p.locationId.toString()]}</td>
                        <td data-label={this.props.translate("PropertySk.CadastreUnit.LandId")}>{p.landId}</td>
                        <td data-label={this.props.translate("PropertySk.CadastreUnit.OwnershipShare")}>{p.share}</td>
                        <td data-label={this.props.translate("PropertySk.CadastreUnit.Burden")}><Translate id={p.burden ? "Common.Yes" : "Common.No"} /></td>
                    </tr>)}
            </>
        );
    }

    expandClicked = () => {
        this.setState({ expanded: !this.state.expanded })
    }

    createOdLink = (cuId, odNo) => {
        if (isNullOrUndefined(cuId) || isNullOrUndefined(odNo))
            return "";

        let query = `?cadastreUnitId=${cuId}&ownershipDeedNo=${odNo}`;
        if (!isNullOrUndefined(this.props.entityId))
            query += `&companyId=${this.props.entityId}`;
        else if (!isNullOrUndefined(this.props.hash))
            query += `&hash=${this.props.hash}`;

        return `ownership-deed${query}`;
    }
}

export default withRouter(withLocalize(connect(
    state => ({ search: { ...state.search }, layout: state.layout }),
    dispatch => bindActionCreators(searchActions, dispatch)
)(PropertySkCadastreUnitParcelList)));